module.exports = __webpack_public_path__ + "static/media/Products_Dogs.1e558dc3.png";